import React, { useState } from 'react'
import { BsArrowRightShort } from 'react-icons/bs'
import { BiPlus } from 'react-icons/bi'
import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react'
import { IoClose } from 'react-icons/io5'

const BusinessOwners = ({ setStep, setMainStep, businessOwner, setBusinessOwner, isUpdate, setData }) => {
    const [add, setAdd] = useState(false)
    const [name, setName] = useState(false)
    const [validName, setValidName] = useState('')
    const [validEmail, setValidEmail] = useState('')

    const handleContinue = () => {
        if(isUpdate){
            setMainStep('step5');
            setStep('Summary');
            setData('default')
        } else {
            setStep('fullfill')
        }
    }

    const handleAddOwner = () => {
        if (!validation()) {
            setAdd(false)
        }
    }

    const validation = () => {
        let valid = false;
        if (businessOwner.owner_first_name === "" || businessOwner.owner_last_name === "") {
            setValidName("Please enter a first and last name.");
            valid = true;
        }
        if (businessOwner.owner_email === "") {
            setValidEmail("Please enter an email address.");
            valid = true;
        }
        return valid;
    }

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    };

    return (
        <div>
            {add ?
                <div>
                    <h3 className='text-[#30313d] sm:text-[32px] text-[24px] font-semibold leading-[36px]'>Add an owner</h3>
                    <p className='text-[#414552] mt-2'>Please add any individual who owns, or is entitled to, 25% or more of your business</p>
                    <div className='sm:mt-[40px] mt-[25px]'>
                        <div>
                            <label htmlFor="legal-name" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Legal name</label>
                            <div className="relative mt-2 w-full">
                                <input
                                    value={businessOwner.owner_first_name}
                                    onChange={(e) => setBusinessOwner({ ...businessOwner, owner_first_name: e.target.value })}
                                    type='text' id="legal-name" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='First name' />
                                <input
                                    value={businessOwner.owner_last_name}
                                    onChange={(e) => setBusinessOwner({ ...businessOwner, owner_last_name: e.target.value })}
                                    type='text' id="legal-name" className="mt-2 input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Last name' />
                                <p className="text-red-600">{businessOwner.owner_first_name === "" || businessOwner.owner_last_name === "" ? validName : ""}</p>
                            </div>
                            <p className='text-sm text-[#414552] mt-2'>Enter your name exactly as it is recorded with the IRS.</p>
                            <p className="text-red-600">{businessOwner.Fname === "" || businessOwner.Lname === "" ? validName : ""}</p>

                        </div>
                        <div className='sm:mt-[30px] mt-[20px]'>
                            <label htmlFor="Email-address" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Email address</label>
                            <div className="relative mt-2 w-full">
                                <input
                                    value={businessOwner.owner_email}
                                    onChange={(e) => setBusinessOwner({ ...businessOwner, owner_email: e.target.value })}
                                    type='text' id="Email-address" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='person@example.com' />
                                <p className="text-red-600">
                                    {businessOwner.owner_email === "" ? validEmail : ""}
                                    {businessOwner.owner_email !== "" && !isValidEmail(businessOwner.owner_email) ? "Please provide a valid email." : ""}
                                </p>
                            </div>
                        </div>
                        <div className='sm:mt-10 mt-5 pb-5'>
                            <button onClick={handleAddOwner} className='rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]'>Add</button>
                            <button onClick={() => setAdd(false)} className='input_focus_shadow mt-3 rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-[#414552]'>Cancel</button>
                        </div>
                    </div>
                </div>
                :
                <div>
                    <h3 className='text-[#30313d] sm:text-[32px] text-[24px] font-semibold leading-[36px]'>Business owners</h3>
                    <p className='text-[#414552] mt-2'>Due to regulatory guidelines, we’re required to collect information on anyone who has significant ownership of your business. <span className='font-semibold text-[#625afa]'>Learn more.</span></p>
                    <div className='sm:mt-[38px] mt-[20px]'>
                        <p className='text-sm text-[#1a1b25] font-semibold'>
                            Please add any individual who owns 25% or more of Applogika LLC.
                        </p>
                        {name ?
                            <div className='mt-6'>
                                <div className='flex justify-between items-center border-[1px] border-[#e3e8ee] p-[12px_16px] bg-[#f7fafc] rounded-[6px] font-semibold text-[#a3acba]'>
                                    Name not provided
                                    <button onClick={() => setName(false)}><IoClose className='text-[20px]' /></button>
                                </div>
                                <button onClick={() => setAdd(true)} className='input_focus_shadow rounded-md mt-2 flex items-center font-medium w-full gap-2 h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]'><BiPlus className='text-[20px]' />Add another owner</button>
                            </div>
                            :
                            <Menu>
                                <MenuHandler>
                                    <button className='input_focus_shadow rounded-md mt-2 flex items-center gap-1 font-medium w-max h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]'><BiPlus className='text-[20px]' />Add a business owner</button>
                                </MenuHandler>
                                <MenuList className='py-[8px] px-0 outline-remove min-w-[168px]'>
                                    <MenuItem onClick={() => setAdd(true)} className='rounded-none w-full px-3 outline-none flex gap-1 items-center font-medium hover:text-[#1a1b25] text-[#625afa] hover:bg-[#f7f7f7] py-[5px]'>Add someone new</MenuItem>
                                    <hr className='my-[8px]' />
                                    <button disabled className='rounded-none text-xs w-full px-3 outline-none flex gap-1 items-center font-medium hover:text-[#687385] text-[#687385] hover:bg-transparent py-[5px]'>SELECT SOMEONE</button>
                                    <MenuItem onClick={() => setName(true)} className='rounded-none w-full px-3 outline-none flex gap-1 items-center font-medium hover:text-[#1a1b25] text-[#a3acba] hover:bg-[#f7f7f7] py-[5px]'>Name not provided</MenuItem>
                                </MenuList>
                            </Menu>
                        }

                        <div className='mt-10 pb-5'>
                            <button onClick={handleContinue} className='rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]'>{name ? "Done, continue" : "Continue with no owners"}<BsArrowRightShort className='text-[25px]' /></button>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default BusinessOwners